export default "__VITE_ASSET__XU8Vv5bB__"